import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import {
  useLocale,
  buildLocalePath,
  getPathWithoutLocale,
} from "../../i18n/LocaleContext";
import { AVAILABLE_LOCALES, DEFAULT_LOCALE } from "../../i18n/locales";

/**
 * Renders SEO tags for internationalization:
 * - HTML lang attribute
 * - Canonical URL
 * - hreflang alternate links for all locales
 * - x-default hreflang for default locale
 */
export function LocaleSEO() {
  const { locale } = useLocale();
  const { pathname } = useLocation();

  const basePath = getPathWithoutLocale(pathname, locale);
  const origin = window.location.origin;

  return (
    <Helmet>
      <html lang={locale} />
      <link rel="canonical" href={`${origin}${buildLocalePath(basePath, locale)}`} />
      {AVAILABLE_LOCALES.map((loc) => (
        <link
          key={loc}
          rel="alternate"
          hrefLang={loc}
          href={`${origin}${buildLocalePath(basePath, loc)}`}
        />
      ))}
      <link
        rel="alternate"
        hrefLang="x-default"
        href={`${origin}${buildLocalePath(basePath, DEFAULT_LOCALE)}`}
      />
    </Helmet>
  );
}

export default LocaleSEO;
